// extracted by mini-css-extract-plugin
export default {"wrap":"leaseActionEdit_wrap__NFs3B","container":"leaseActionEdit_container__suISX"};